import { getGenericFormInitialValues } from "../../../components/form/utils/initialValues";

export const getLillyCopayFormInitialValues = ({ applicationForm, formJson }) => {
  const initialValues = getGenericFormInitialValues(applicationForm, formJson);

  // EE TODO: add here specific manipulations for initial values - if needed

  return initialValues;
};
